import { motion } from "framer-motion";
import MarqueeRibbon from "react-fast-marquee";

const photos = [
  { src: "/assets/gallery/travail-1.webp", alt: "iPhone ouvert pendant une réparation d'écran" },
  { src: "/assets/gallery/travail-2.jpeg", alt: "Coque arrière iPhone cassée remplacée : avant et après" },
  { src: "/assets/gallery/travail-3.webp", alt: "Batterie iPhone remplacée, capacité maximum 100 %" },
  { src: "/assets/gallery/travail-4.jpeg", alt: "Vitre arrière iPhone réparée : avant après" },
];

export const Gallery = () => {
  return (
    <section id="galerie" className="relative py-28 lg:py-40 bg-white border-y border-zinc-200" data-testid="gallery-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <motion.h2
          className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight uppercase text-zinc-950 mb-8"
        >
          Notre travail <span className="text-chrome">en images</span>
        </motion.h2>
        <motion.p
          className="max-w-2xl text-base md:text-lg font-light text-zinc-600 mb-16"
        >
          Chaque réparation est réalisée avec soin.
        </motion.p>

        <motion.div
        >
          <MarqueeRibbon speed={35} gradient={false} pauseOnHover={true}>
            {photos.map((photo, i) => (
              <figure
                key={photo.src}
                className="group relative mx-3 h-64 w-96 shrink-0 overflow-hidden rounded-lg border border-zinc-200"
                data-testid={`gallery-photo-${i + 1}`}
              >
                <img
                  src={photo.src}
                  alt={photo.alt}
                  loading="lazy"
                  className="h-full w-full object-cover grayscale-[30%] contrast-110 transition-all duration-700 group-hover:scale-110 group-hover:grayscale-0"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent opacity-60 group-hover:opacity-20 transition-opacity duration-500" aria-hidden="true" />
              </figure>
            ))}
          </MarqueeRibbon>
        </motion.div>
      </div>
    </section>
  );
};
